import GenelDurumHelper from "../../helpers/GenelDurumHelper";
import StringHelper from "../../library/helpers/StringHelper";
import CsmFreeAutoCompleteField, { ICsmFreeAutoCompleteFieldProps } from "../../library/components/mui/select/CsmFreeAutoCompleteField";

export type IVatanDonemFieldProps = Omit<ICsmFreeAutoCompleteFieldProps, "sourceList"> & {
    genelDurumHelper: GenelDurumHelper,
}

function VatanDilField(props: IVatanDonemFieldProps) {
    const { genelDurumHelper, ...rest } = props;

    const sourceList = genelDurumHelper.SeciliKoroModel.tumSarkilar
        .where(e => StringHelper.isNotEmpty(e.dil))
        .select(e => e.dil!)
        .distinct()
        .orderByTurkish(e => e);

    return <CsmFreeAutoCompleteField
        sourceList={sourceList}
        {...rest}
    />
}

export default VatanDilField;